import { call, put } from "redux-saga/effects";
import { authApi } from "@services/api";
import { loginActions } from "../slices";

function* loginWorker({ payload }) {
  yield put(loginActions.pending());
  try {
    const response = yield call(authApi.login, payload);
    yield put(loginActions.success({ ...response, loginInfo: payload }));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(loginActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { loginWorker };
